import React from "react";

export const responsiveSizeClasses: {[key in 'xs' | 'sm' | 'md' | 'lg' | 'xl'] : string} = {
  xs: 'w-1rem h-1rem md:w-2rem md:h-2rem',
  sm: 'w-1-5rem h-1-5rem md:w-3rem md:h-3rem',
  md: 'w-2rem h-2rem md:w-3rem md:h-3rem',
  lg: 'w-3rem h-3rem md:w-3rem md:h-3rem',
  xl: 'w-8rem h-8rem md:w-8rem md:h-8rem',
};
